export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
export const API_URL = process.env.REACT_APP_API_URL
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT
export const MEETING_SOCKET_URL = process.env.REACT_APP_MEETING_SOCKET_URL
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY
export const MEDIA_SERVER_URL_MAP = {
  '3.140.89.53:9292': 'wss://mediaserver1.coderscout.io',
  '3.142.15.75:9292': 'wss://mediaserver2.coderscout.io',
  '3.21.223.89:9292': 'wss://mediaserver3.coderscout.io'
}
export const INTERNET_SPEED_TEST_URL = 'https://api.coderscout.io:9294/'
